'use client'

import { TradeIn } from 'src/screens/services-trade-in'

import { CatalogItem } from '@/entities/catalog/types'

type Props = {
	catalogItems: CatalogItem[]
}

const ServicesTradeInPageContent = ({ catalogItems }: Props) => {
	return <TradeIn catalogItems={catalogItems} />
}

export function ServicesTradeInClient({ catalogItems }: Props) {
	return <ServicesTradeInPageContent catalogItems={catalogItems} />
}
